import log from "loglevel";

export enum SessionStorageItems {
    CART = "warenkorb",
    CUSTOMER = "customer",
    STEPCOUNTER = "stepCounter",
    CAMPAIGN = "campaign",
    DIRECT_PURCHASE = "directPurchase"
}

export default interface SessionStorageProviderProps {
    logger?: log.RootLogger;
}